<div class="flex flex-col soft-card h-full !p-4">
  <div class="ds-overline">{{'#TIMESTAMP.TITLE' | translate}}</div>

  <div class="flex flex-col gap-y-2 mt-2 h-full">
    @for (timestamp of timestamps(); track timestamp.id) {
    <div class="flex flex-row items-center">
      <div
        class="w-1 rounded h-6"
        [style.background]="
          timestamp.flag === 'arrival'
            ? 'var(--ds-surface-status-success)'
            : 'var(--ds-surface-status-warning)'
        "
      ></div>
      <span class="stamp-title ml-2 inline-block w-12 tabular-nums">
        {{$safeNavigationMigration(timestamp?.timestamp) | date: 'HH:mm' }}
      </span>
      <span class="ml-4">
        {{(timestamp.flag === 'arrival' ? '#TIMESTAMP.TYPE.ARRIVAL' :
        '#TIMESTAMP.TYPE.DEPARTURE') | translate}}
      </span>
      <div class="flex flex-row">
        @if (timestamp.code) {
        <span class="ml-8 stamp-information">
          ({{ timestamp.code.name }} @if (timestamp.code.description) { -&nbsp;{{
          timestamp.code.description }} })
        </span>
        }
      </div>
    </div>

    } @empty { @if (loaded() && !loading()) {
    <div
      class="ds-body-2 my-4 w-full flex flex-row col-span-5 items-center justify-center"
      style="color: var(--ds-text-secondary)"
    >
      {{ '#TIMESTAMP.NO_DATA' | translate }}
    </div>
    } @else {
    <ng-container *softRepeat="3">
      <div class="flex flex-row items-center gap-2">
        <soft-ds-loading-skeleton width="0.25rem" height="1.5rem" />
        <soft-ds-loading-skeleton width="3rem" height="1rem" />
        <span style="display: block; margin-left: var(--ds-spacing-5)">
          <soft-ds-loading-skeleton width="4rem" height="1rem" />
        </span>
        <span style="display: block; margin-left: var(--ds-spacing-11)">
          <soft-ds-loading-skeleton width="6rem" height="1rem" />
        </span>
      </div>
    </ng-container>
    } }
  </div>
  <soft-ds-button variant="primary" size="lg" class="mt-4" (click)="onCreate()">
    <i class="fa-regular fa-stopwatch mr-2"></i>
    {{'#TIMESTAMP.RECORD_TIMESTAMP' | translate}}
  </soft-ds-button>
</div>
